<template>
  <ul class="rewards-list">
    <li
      v-for="(reward, index) in rewards"
      v-bind:key="index"
      class="rewards-list_item"
    >
      <img class="rewards-list_item-img" :src="reward.img" alt="">
      <div class="rewards-list_item-title" v-html="reward.title" />
    </li>
  </ul>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
const randomRewards = namespace('randomRewards')

@Component({
  components: {}
})
class RewardsList extends Vue {
  // fetchRewards
  @randomRewards.Action('fetchRewards') fetchRewards
  @randomRewards.State('rewards') rewards
  created () {
    this.fetchRewards()
  }
}
export default RewardsList
</script>

<style lang="scss">
  .rewards-list {
    margin-top: 32px;
    @include media_tablet {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      margin-top: 50px;
    }
    &_item {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 6px;
      @include media_tablet {
        flex-direction: column;
        margin-bottom: 80px;
      }
    }
    &_item-img {
      width: 70px;
      margin-bottom: 0;
      margin-right: 5px;
      height: auto;
      @include media_tablet {
        width: auto;
        height: 100px;
      }
      @include media_desktop {
        margin-bottom: 25px;
        margin-right: 0;
        width: auto;
        height: 300px;
      }
    }
    &_item-title {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 22px;
      text-align: left;
      color: #FFFFFF;
      @include media_desktop {
        font-size: 20px;
        line-height: 25px;
        text-align: center;
      }
    }
  }
  .gold {
    color: #FEB62F;
  }
</style>
